module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fVoWD"))).then(() => parcelRequire('cvs7o'));